import callBackendApi from './call';

export interface ElectionElectorateRecord {
  id: number;
  name: string;
  electionId: number;
}

export const getElectionElectoratesByIds = async (
  token: string,
  ids: number[],
  abortSignal?: AbortSignal
) => {
  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/electorates?ids=${JSON.stringify(ids)}`,
    abortSignal,
  });
  return data as ElectionElectorateRecord[];
};
